import { render } from "./create_ward_modal.vue?vue&type=template&id=3eddec5c&scoped=true"
import script from "./create_ward_modal.vue?vue&type=script&lang=js"
export * from "./create_ward_modal.vue?vue&type=script&lang=js"

import "./create_ward_modal.vue?vue&type=style&index=0&id=3eddec5c&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eddec5c"]])

export default __exports__